import { combineReducers, configureStore } from "@reduxjs/toolkit";
import shipSlice from "./slice/shipSlice/shipSlice";
import ownerSlice from "./slice/ownerslice/ownerslice";
import { persistReducer, persistStore } from "redux-persist";
import dailySlice from "./slice/reportSlice/dailySlice";
import portSlice from "./slice/portSlice/portSlice";
import storage from "redux-persist/lib/storage";
import errorSlice from "./slice/errorSlice/errorSlice";
import permissionsSlice from "./slice/permissionSlice/index";
import tourSlice from "./slice/tourSlice/tourSlice";
import authSlice from "./slice/authSlice";

const rootReducer = combineReducers({
  ship: shipSlice,
  owner: ownerSlice,
  dailyReport: dailySlice,
  portInfo: portSlice,
  errorInfo: errorSlice,
  permission: permissionsSlice,
  tour: tourSlice,
  auth: authSlice,

});

const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "dailyReport",
    "portInfo",
    "errorInfo",
    "tour",
    "auth",
  ],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  devTools: import.meta.env.mode !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          "persist/PERSIST",
          "persist/REHYDRATE",

        ],
      },
    }),
});

const persistor = persistStore(store);
export { store, persistor };
